// U1's zoomMeetings switch as the pages see it (D15). Read once when the app
// starts; off until it is read, and off if it cannot be read, so a page
// never offers Zoom the API would refuse. Screens that need Zoom's state
// load it only while the switch is on.
import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { useApi } from '../app/api-context';

const ZoomSwitchContext = createContext(false);

export function ZoomSwitchProvider(props: { children: ReactNode }) {
  const api = useApi();
  const [isOn, setIsOn] = useState(false);

  useEffect(() => {
    let isCurrent = true;
    api
      .get<{ zoomMeetings?: unknown }>('/api/v1/public/features')
      .then((features) => {
        if (isCurrent) setIsOn(features.zoomMeetings === true);
      })
      // Unreadable switches keep Zoom hidden; nothing the person started fails.
      .catch(() => undefined);
    return () => {
      isCurrent = false;
    };
  }, [api]);

  return <ZoomSwitchContext.Provider value={isOn}>{props.children}</ZoomSwitchContext.Provider>;
}

// A fixed switch, for tests and previews.
export function FixedZoomSwitch(props: { isOn: boolean; children: ReactNode }) {
  return (
    <ZoomSwitchContext.Provider value={props.isOn}>{props.children}</ZoomSwitchContext.Provider>
  );
}

export const useIsZoomOn = () => useContext(ZoomSwitchContext);
